import { authRef, homeUrl } from 'config'

import { insertNewValue } from '../insertNewValue'

export const signInWithoutPassword = (
  email: string,
  type: string,
  userData: any,
  successCallback: () => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async () => {
  const actionCodeSettings = {
    url: `${homeUrl}/confirmation/${email}`,
    handleCodeInApp: true
  }

  authRef
    .sendSignInLinkToEmail(email, actionCodeSettings)
    .then(() => {
      if (type === 'parent' || type === 'educator') {
        userData.email = email
        userData.userRole = type

        const usersTableData = {
          email,
          full_name: userData.full_name,
          role: type,
          children: userData.children || null
        }

        insertNewValue(email, usersTableData, 'users_tmp', true)
          .then(() => {
            successCallback()
          })
          .catch(error => {
            const { message } = error
            errorCallback(message)
          })
      } else {
        const message = 'Missing type of registration'
        errorCallback(message)
      }
    })
    .catch(error => {
      const { message } = error
      errorCallback(message)
    })
}



// WEBPACK FOOTER //
// ./src/store/user/actions/signInWithoutPassword.action.ts